module.exports = __webpack_public_path__ + "static/media/Stock.f7a9f5aa.png";